import { useEffect } from "react";
import { getUniqueIdForContentTypeAlias } from "../logic/contentLogic";

import classnames from "classnames";
import { Grid, GridColumn, GridRow } from "../bob-web-library/components";
import { contentTypeAliasAsCssClass, get, getPropVariant } from "../logic/contentLogic";

const HUBSPOT_PORTAL_ID = "144291374";
const HUBSPOT_REGION = "eu1";
const HUBSPOT_SCRIPT_SRC = `https://js-${HUBSPOT_REGION}.hsforms.net/forms/embed/${HUBSPOT_PORTAL_ID}.js`;

const HubspotForm = ({ formId }) => {
  useEffect(() => {
    // Check if script is already loaded
    const existingScript = document.querySelector(`script[src="${HUBSPOT_SCRIPT_SRC}"]`);
    if (!existingScript) {
      const script = document.createElement("script");
      script.src = HUBSPOT_SCRIPT_SRC;
      script.defer = true;
      document.body.appendChild(script);
    }
  }, []);

  return <div className="hs-form-frame" data-region={HUBSPOT_REGION} data-form-id={formId} data-portal-id={HUBSPOT_PORTAL_ID} />;
};

export const renderNestedHubspotForm = (content, props = {}) => {
  const formId = get(content, "props.formID.value", undefined);
  const alignItem = get(content, "props.alignItem.value", undefined);

  if (!formId) {
    return null;
  }

  return (
    <Grid key={getUniqueIdForContentTypeAlias(content.contentTypeAlias)}>
      <GridRow
        key={getUniqueIdForContentTypeAlias(content.contentTypeAlias)}
        className={classnames("row-content", contentTypeAliasAsCssClass(content.contentTypeAlias))}
        alignItem={getPropVariant(alignItem)}
      >
        <GridColumn
          key={getUniqueIdForContentTypeAlias(content.contentTypeAlias)}
          className={classnames("column-content", contentTypeAliasAsCssClass(content.contentTypeAlias))}
          span={6}
          offset={4}
        >
          <HubspotForm formId={formId} />
        </GridColumn>
      </GridRow>
    </Grid>
  );
};
